import * as v from 'valibot';
import { GenericSchema } from 'valibot';

export const ResultsAndCount = <Output>(Schema: GenericSchema<Output>) => {
	return v.object({
		results: v.array(Schema),
		count: v.number(),
	});
};

export type ResultsAndCount<T> = {
	results: T[];
	count: number;
};

const OpeningClosingTime = v.object({
	dayOfWeek: v.string(),
	openingTime: v.nullable(v.string()),
	closingTime: v.nullable(v.string()),
	open24Hours: v.string(),
});

const SeasonalityPeriod = v.object({
	reason: v.string(),
	fromDate: v.string(), // YYYY-MM-DD
	toDate: v.string(), // YYYY-MM-DD
	comment: v.string(),
});

const BusinessClosedPeriod = v.object({
	reason: v.string(),
	fromDate: v.string(), // YYYY-MM-DD
	toDate: v.string(), // YYYY-MM-DD
});

export const DataField = v.object({
	name: v.string(),
	value: v.nullish(
		v.union([
			v.string(),
			v.array(SeasonalityPeriod),
			v.array(OpeningClosingTime),
			v.array(BusinessClosedPeriod),
		]),
	),
	type: v.picklist(['string', 'date', 'boolean', 'table']),
	isDefault: v.optional(v.boolean()),
});

export type DataField = v.InferOutput<typeof DataField>;

export const DataGroup = v.object({
	groupName: v.string(),
	fields: v.array(DataField),
});

export type DataGroup = v.InferOutput<typeof DataGroup>;

export const DynamicData = v.array(DataGroup);
export type DynamicData = v.InferOutput<typeof DynamicData>;

export const TimeType = v.picklist([0, 1, 2]);
export type TimeType = v.InferOutput<typeof TimeType>;

export const timeNames: Record<TimeType, 'Days' | 'Weeks' | 'Months'> = {
	0: 'Days',
	1: 'Weeks',
	2: 'Months',
} as const;

export const timePeriodNames: Record<TimeType, 'Daily' | 'Weekly' | 'Monthly'> =
	{
		0: 'Daily',
		1: 'Weekly',
		2: 'Monthly',
	} as const;

export const defaultTimeType = 2;

export type Int<T extends `${number}`> =
	T extends `${infer Digit extends number}` ? Digit : never;

//      Value= 1,
//      CategoryByMI = 2,
//      BothWithMI = 3,
//      CategoryByAI = 4,
//      BothWithAI = 5
export const MIType = v.picklist([1, 2, 3, 4, 5]);

export const Currency = v.picklist(['USD', 'CAD', 'GBP']);
export type Currency = v.InferOutput<typeof Currency>;

export type Stage = 'Draft' | 'Active' | 'Closed';
